import { Model } from "pinia-orm";
export default class Question extends Model {
  static name = "Question";
  static entity = "questions";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      createdAt: this.string(""),
      updatedAt: this.string(""),
      createdBy: this.string(""),
      modifiedBy: this.string(""),
      batches: this.attr([]),
      questionType: this.string(""),
      isMandatory: this.boolean(false),
      text: this.string(""),
      title: this.string(""),
      isArchived: this.boolean(false),
      isPublished: this.boolean(false),
      choices: this.attr([]),
      relatedObjectUuid: this.string(null),
      notation: this.number(0),
      correctChoicesNumber: this.number(0),
      questionnaireDocuments: this.attr([]),
      extraData: this.attr({}),
      questionnaireSessionQuestionUuid: this.string(null),
      answer: this.attr(null),
    };
  }
}
